/** @format */

import * as bemCn from 'bem-cn';
import * as React from 'react';

import './style.styl';

interface TooltipRightProps {
    text: React.ReactNode;
    icon: React.ReactNode;
}

export const TooltipRight = (props: TooltipRightProps) => {
    const blockName = bemCn('tooltip-right');
    const refHideBlock = React.useRef<HTMLDivElement>(null);
    const refIcon = React.useRef<HTMLDivElement>(null);
    const refRow = React.useRef<HTMLDivElement>(null);
    const [hideBlockStyle, setHideBlockStyle] =
        React.useState<React.CSSProperties>();

    const [show, setShow] = React.useState(false);
    const [hidden, setHidden] = React.useState(true);

    const [arrowStyle, setArrowStyle] = React.useState<React.CSSProperties>({});
    React.useEffect(() => {
        if (refHideBlock.current && refIcon.current && refRow.current) {
            const iconStyle = getComputedStyle(refIcon.current, null);
            const hideBlockStyle = getComputedStyle(refHideBlock.current, null);
            const rowStyle = getComputedStyle(refRow.current, null);

            setHideBlockStyle({
                top:
                    (Math.abs(
                        parseInt(iconStyle.height, 10) -
                            parseInt(hideBlockStyle.height, 10)
                    ) /
                        2) *
                    -1,
                left: parseInt(iconStyle.height, 10),
            });
            setArrowStyle({
                top:
                    parseInt(hideBlockStyle.height, 10) / 2 -
                    parseInt(rowStyle.height, 10) / 2,
            });
        }
    }, []);
    return (
        <div ref={refIcon} className={blockName()}>
            <span
                onMouseOver={() => {
                    setHidden(false);
                    setShow(true);
                }}
                onMouseOut={() => {
                    setShow(false);
                }}
                className={blockName('icon')()}
            >
                {props.icon}
            </span>
            <div
                style={hideBlockStyle}
                className={blockName('hide_block_container')()}
            >
                <div
                    ref={refRow}
                    style={arrowStyle}
                    className={blockName('arrow_container')()}
                >
                    <div ref={refRow} className={blockName('arrow')()} />
                </div>

                <div
                    ref={refHideBlock}
                    className={blockName('hide_block')({
                        show: show,
                        hidden: hidden,
                    })()}
                >
                    {props.text}
                </div>
            </div>
        </div>
    );
};
